// SKIN-613. ICD-11 chapters X (Extension codes: substances, animals, objects,
// histopathology morphology) and V (Supplementary section for functioning
// assessment) are never a diagnosis on their own. The SkincAIr app stored 60
// chapter X picks as diagnoses in 6 production visits ("XE69N Parrot,
// parakeet, cockatoo" as a derm diagnosis) before its picker excluded them;
// the web picker applies the same rule.

/**
 * The chapters the WHO coding tool searches: 01-25, the diagnosis chapters.
 *
 * Written out rather than left to the library default. The default happens to
 * be this same set today (26, V and X are off in @whoicd/icd11ect 1.7.1), but
 * nothing pinned it, so a library upgrade could widen the search silently.
 * Chapter 26 (Traditional Medicine) stays excluded, as it already was on the
 * web: whether to offer it is a clinical decision, not part of SKIN-613.
 */
export const DIAGNOSIS_CHAPTERS_FILTER = Array.from({ length: 25 }, (_, i) =>
    String(i + 1).padStart(2, '0'),
).join(';');

/**
 * False for a bare chapter X or V code. Keyed on the first character, so a
 * postcoordinated cluster that starts with a diagnosis ("2F25&XH9Q71") is
 * still accepted: only an extension or functioning code standing alone is
 * refused.
 *
 * Needed on top of {@link DIAGNOSIS_CHAPTERS_FILTER} because the tool's
 * chapter panel lets the user widen the search to every chapter.
 */
export function isDiagnosisCode(code: string | undefined | null): boolean {
    if (!code) return false;
    return !code.startsWith('X') && !code.startsWith('V');
}
